import { PROV } from './observer.js';
export const SPHERE_CHAPTER = {
    sostoyanie: { chapterId: 'glava-10-elektriceskij-zarad-set-tanetsa-k-emocii', hint: 'электрический заряд' },
    zdorovie: { chapterId: 'glava-9-klejkie-kapli-ustojcivost-sistemy', hint: 'клейкие капли' },
    otnosheniya: { chapterId: 'glava-11-vibracii-seti', hint: 'вибрации сети' },
    prostranstvo: { chapterId: 'glava-8-pletenie-pautiny-sozdanie-konteksta', hint: 'плетение контекста' },
    dengi: { chapterId: 'glava-14-ekonomika-selka-pererabotka-resursov', hint: 'экономика шёлка' },
    produkt: { chapterId: 'glava-17-evolucia-seti--stil-i-podpis', hint: 'стиль и подпись' },
    vliyanie: { chapterId: 'glava-12-obmotka-i-ad-zakreplenie-vnimania', hint: 'закрепление внимания' },
    realizatsiya: { chapterId: 'glava-16-terpenie--sila-nepodvijnosti', hint: 'терпение' },
};
/** когда все сферы над ватерлинией, разговор идёт о самой суперпозиции */
export const BALANCED_CHAPTER = {
    chapterId: 'glava-2-superpozicia',
    hint: 'суперпозиция',
};
// действие каждой провокации уникально, поэтому старые записи наблюдателя
// тоже находят свою главу — ничего дописывать в сохранённое состояние не нужно
const BY_ACT = new Map();
for (const [sphere, variants] of Object.entries(PROV)) {
    for (const v of variants)
        BY_ACT.set(v[2], SPHERE_CHAPTER[sphere]);
}
// формулировки, переписанные без обращения к одному полу: старые записи с ними
// по-прежнему ведут в свою главу
BY_ACT.set('напиши одному человеку, которого давно продинамила. сегодня.', SPHERE_CHAPTER.otnosheniya);
/** глава книги под этой записью наблюдателя */
export function methodFor(obs) {
    return BY_ACT.get(obs.act) ?? BALANCED_CHAPTER;
}
//# sourceMappingURL=method.js.map